import { createContext } from "react";

type ContextType = {height : number}
const ContentHeightContext = createContext<ContextType>({height: 0});

export default ContentHeightContext;